import { render, staticRenderFns } from "./CoursesFilterDropdown.vue?vue&type=template&id=46e3ab5a&"
import script from "./CoursesFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./CoursesFilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports